import { render, staticRenderFns } from "./DigitalHuman.vue?vue&type=template&id=49a8ccf4&scoped=true"
import script from "./DigitalHuman.vue?vue&type=script&lang=js"
export * from "./DigitalHuman.vue?vue&type=script&lang=js"
import style0 from "./DigitalHuman.vue?vue&type=style&index=0&id=49a8ccf4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49a8ccf4",
  null
  
)

export default component.exports